import { makeStyles } from "@material-ui/core/styles";
import { h6Semibold, h7Medium, h7Regular } from "../../../shared/typography";
import { withOpacity } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  OrdersHistoryCardContainer: {
    background: "#fff",
    borderRadius: 16,
    padding: 24,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },
  OrdersHistoryCardItems: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  OrdersHistoryCardDeliveryItem: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  OrdersHistoryCardDeliveryItemHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  OrdersHistoryCardDeliveryItemHeaderDate: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
  },
  OrdersHistoryCardDeliveryItemDay: {
    ...h7Medium,
    ...withOpacity(0.8),
  },
  OrdersHistoryCardDeliveryItemDayCancelled: {
    ...h7Regular,
    ...withOpacity(0.4),
  },
  OrdersHistoryCardDeliveryItemDate: {
    ...h7Regular,
    ...withOpacity(0.8),
  },
  OrdersHistoryCardFooter: {
    paddingTop: 16,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  OrdersHistoryCardTotal: {
    ...h6Semibold,
    ...withOpacity(0.8),
  },
  OrdersHistoryCardMultipleDeliveries: {
    ...h7Regular,
    ...withOpacity(0.4),
  },
  OrdersHistoryCardDeliveryItemDivider: {
    height: 1,
    borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
  },
}));
